import type { ConsentState } from "./types";

const COOKIE = "dp_cid";
const STATE_KEY = "dp_consent_state";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 396; // ~13 months in seconds

function readCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

function uuid(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) return crypto.randomUUID();
  return "cid-" + Date.now().toString(16) + "-" + Math.random().toString(16).slice(2);
}

export function getOrCreateCookieId(): string {
  const existing = readCookie(COOKIE);
  if (existing) return existing;
  const id = uuid();
  document.cookie = `${COOKIE}=${encodeURIComponent(id)}; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax`;
  return id;
}

export function loadState(): ConsentState | null {
  try {
    const raw = localStorage.getItem(STATE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ConsentState;
  } catch {
    return null;
  }
}

export function saveState(state: ConsentState): void {
  try {
    localStorage.setItem(STATE_KEY, JSON.stringify(state));
  } catch {
    /* localStorage disabled — degrade silently */
  }
}
